import { Link } from 'react-router-dom'

import { useTheme } from '../hooks/useTheme'


//styles
import './Navbar.css'

//components
import Searchbar from './Searchbar'
import ThemeSelector from './ThemeSelector'


export default function Navbar() {
  let { color } = useTheme()

  return (
    <div>
    <div className='navbar' style={{background: color}} >
        <nav>

            <Link to="/" className='brand'>
                <h1>  कु King 👨‍🍳 👑</h1>
            </Link>

            <Searchbar />

            <Link to="/create">
                Create Recipe
            </Link>

            
        </nav>
    </div>
        <ThemeSelector />
    </div>
  )
}
